module.exports = __webpack_public_path__ + "img/infinity-loader_matting.f59afd4.gif";